import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import CustomerAuth from './CustomerAuth';
import TokenAuth from './TokenAuth';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import VerifyEmail from './VerifyEmail';
import CustomerDashboard from './CustomerDashboard';
import CheckoutBridge from './CheckoutBridge';
import DigitalDownload from './DigitalDownload';
import NotFound from './components/NotFound';
import ErrorBoundary from './components/ErrorBoundary';

function CustomerApp() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div className="customer-app">
          <Routes>
          {/* Public Digital Download Route (accessed via email links) */}
          <Route path="/download/:token" element={<DigitalDownload />} />

          {/* Customer Authentication Routes */}
          <Route path="/auth" element={<TokenAuth />} />
          <Route path="/login" element={<CustomerAuth />} />
          <Route path="/register" element={<CustomerAuth />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Customer Dashboard Routes - All protected routes go through dashboard */}
          <Route path="/dashboard/*" element={<CustomerDashboard />} />

          {/* Bridge checkout to merchant app while preserving session */}
          <Route path="/checkout" element={<CheckoutBridge />} />

          {/* Redirect standalone routes to dashboard equivalents */}
          <Route path="/profile" element={<Navigate to="/dashboard/profile" replace />} />
          <Route path="/orders" element={<Navigate to="/dashboard/orders" replace />} />
          <Route path="/addresses" element={<Navigate to="/dashboard/addresses" replace />} />
          <Route path="/wishlist" element={<Navigate to="/dashboard/wishlist" replace />} />
          <Route path="/promotions" element={<Navigate to="/dashboard/promotions" replace />} />
          <Route path="/analytics" element={<Navigate to="/dashboard/analytics" replace />} />
          <Route path="/notifications" element={<Navigate to="/dashboard/notifications" replace />} />
          <Route path="/refunds" element={<Navigate to="/dashboard/refunds" replace />} />

          {/* Aliases for /customer/* paths to maintain parity with merchant app */}
          <Route path="/customer/login" element={<Navigate to="/login" replace />} />
          <Route path="/customer/register" element={<Navigate to="/register" replace />} />
          <Route path="/customer/forgot-password" element={<Navigate to="/forgot-password" replace />} />
          <Route path="/customer/reset-password" element={<Navigate to="/reset-password" replace />} />
          <Route path="/customer/verify-email" element={<Navigate to="/verify-email" replace />} />
          <Route path="/customer/dashboard" element={<Navigate to="/dashboard" replace />} />
          <Route path="/customer/profile" element={<Navigate to="/dashboard/profile" replace />} />
          <Route path="/customer/orders" element={<Navigate to="/dashboard/orders" replace />} />
          <Route path="/customer/addresses" element={<Navigate to="/dashboard/addresses" replace />} />
          <Route path="/customer/wishlist" element={<Navigate to="/dashboard/wishlist" replace />} />
          <Route path="/customer/promotions" element={<Navigate to="/dashboard/promotions" replace />} />
          <Route path="/customer/analytics" element={<Navigate to="/dashboard/analytics" replace />} />
          <Route path="/customer/notifications" element={<Navigate to="/dashboard/notifications" replace />} />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" />} />

          {/* Catch-all for unknown routes - show 404 page */}
          <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default CustomerApp;
